import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";

/**
 * Lightweight user shape stored in Redux (from /auth/verify response).
 * This is the common subset used by both frontends.
 */
export interface SharedUser {
  id: number;
  nombreUsuario: string;
  nombre: string;
  apellidoPaterno: string;
  apellidoMaterno: string;
  correo: string;
  ultimoAcceso: string;
  rol: {
    id: number;
    nombre: string;
    descripcion: string;
  };
  avatar?: string;
}

const getUserFromStorage = (): SharedUser | null => {
  const stored = localStorage.getItem("currentUser");
  return stored ? JSON.parse(stored) : null;
};

const initialState: SharedUser | null = getUserFromStorage();

export const currentUserSlice = createSlice({
  name: "currentUser",
  initialState,
  reducers: {
    setUser: (_: unknown, action: PayloadAction<SharedUser>) => {
      localStorage.setItem("currentUser", JSON.stringify(action.payload));
      return action.payload;
    },
    logout: () => {
      localStorage.removeItem("currentUser");
      return null;
    },
  },
});

export const { setUser, logout } = currentUserSlice.actions;
export default currentUserSlice.reducer;
